import { useSoundStore } from "@shared/store/soundStore";

// Bundleados con Vite desde /public — se sirven como assets estáticos, no
// pasan por el bundle JS.
//   send.wav    — pop sintetizado: sine sweep 800→200Hz + ruido breve al
//                 ataque + decay exponencial. Burbuja suave, no agresivo.
//   receive.mp3 — ding de Mixkit, breve y limpio para nuevos mensajes.
const SEND_SOUND = "/sounds/send.wav";
const RECEIVE_SOUND = "/sounds/receive.mp3";

// Los <audio> base se reutilizan entre llamadas; cada play() clona para que
// clicks rápidos se solapen sin cortarse entre sí.
let sendBase: HTMLAudioElement | null = null;
let receiveBase: HTMLAudioElement | null = null;

function play(asset: HTMLAudioElement | null, volume: number) {
	if (!asset) return;
	if (!useSoundStore.getState().enabled) return;
	const sound = asset.cloneNode(true) as HTMLAudioElement;
	sound.volume = volume;
	// Tab no activa / autoplay policy / browser bloquea → silencio sin error.
	sound.play().catch(() => {});
}

function getOrCreate(
	base: HTMLAudioElement | null,
	src: string,
): HTMLAudioElement {
	if (base) return base;
	const el = new Audio(src);
	return el;
}

/**
 * Reproduce el sonido de "swoosh" al enviar un mensaje. Lo usan el
 * ChatComposer (vía useChatSounds) y cualquier otro lugar que necesite
 * reproducir el mismo feedback sin necesidad de un componente React.
 */
export function playSendSound() {
	const asset = getOrCreate(sendBase, SEND_SOUND);
	sendBase = asset;
	play(asset, 0.3);
}

/**
 * Reproduce el "ding" al recibir un mensaje nuevo. Lo llama el
 * WebSocketProvider desde el handler de `message.incoming`.
 */
export function playReceiveSound() {
	const asset = getOrCreate(receiveBase, RECEIVE_SOUND);
	receiveBase = asset;
	play(asset, 0.35);
}
